import { Triangle, Grid3x3, Axis3d } from 'lucide-react';
import { Slider } from '@patientMenu/patientDetail/Slider.tsx';
import { useTeeth } from '@patientMenu/hooks/useTeeth.ts';

export function TeethViewerOptions() {
  const {
    upperOpacity,
    lowerOpacity,
    showAxes,
    showGrid,
    showUpperJaw,
    showLowerJaw,

    toggleAxes,
    toggleGrid,
    toggleUpperJaw,
    toggleLowerJaw,
    setUpperOpacity,
    setLowerOpacity,
  } = useTeeth();

  const handleUpperClick = () => {
    const newShowUpperJaw = !showUpperJaw;
    toggleUpperJaw();
    setUpperOpacity(newShowUpperJaw ? 100 : 0);
  };

  const handleLowerClick = () => {
    const newShowLowerJaw = !showLowerJaw;
    toggleLowerJaw();
    setLowerOpacity(newShowLowerJaw ? 100 : 0);
  };

  return (
    <div className="space-y-2">
      <div className="flex text-sm items-center space-x-2">
        <Triangle className={`cursor-pointer transform ${showUpperJaw ? 'text-blue-500' : 'text-modalQuestion'}`} onClick={handleUpperClick} />
        <Slider label="Upper Opacity" value={upperOpacity} onChange={setUpperOpacity} />
      </div>

      <div className="flex text-sm items-center space-x-2">
        <Triangle className={`cursor-pointer transform rotate-180 ${showLowerJaw ? 'text-blue-500' : 'text-modalQuestion'}`} onClick={handleLowerClick} />
        <Slider label="Lower Opacity" value={lowerOpacity} onChange={setLowerOpacity} />
      </div>
    </div>
  );
}
